import React from "react";

const NoPoster = (props) => {
    return (
        <div className="imgCard">
            <div className="cardMediaImg">
                <div className="noBnrBox">
                    <img src="/images/icons/no-banner.png" alt="coverimg" className="invertPrimary"/>
                </div>
                <div className="cardMdaHdr">
                    <span className="cardHdngtxt">{props.heading}</span>
                </div>
            </div>
        </div>
    )
}

export default NoPoster;